export const SEARCH_LINK = `${window.location.origin}/wp-json/newsbx/v1/search?term=`;
